import axiosInstance from "@/api/axiosInstance";

export interface ProductCategoryData {
  id?: number;
  name: string;
  description: string | null;
  isActive: boolean;
  createdAt?: string | null;
  productCount?: number;
}

export const fetchProductCategories = async () => {
  const response = await axiosInstance.get("/api/private/product-categories");
  return response.data;
};

export const createProductCategory = async (data: { name: string; description?: string | null; isActive: boolean }) => {
  const response = await axiosInstance.post("/api/private/product-category/create", data);
  return response.data;
};

export const updateProductCategory = async (id: number, data: { name: string; description?: string | null; isActive: boolean }) => {
  const response = await axiosInstance.put(`/api/private/product-category/${id}/update`, data);
  return response.data;
};

export const deleteProductCategory = async (id: number) => {
  const response = await axiosInstance.delete(`/api/private/product-category/${id}/delete`);
  return response.data;
};
